import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import styles from './OrdersPage.module.css';

const COLORS = {
  navy: '#0E1333',
  blue: '#3B82F6',
  green: '#10B981',
  muted: '#64748b',
};

export type SuccessType = 'sent' | 'received' | null;

export function SuccessOverlay({ type, onDismiss }: {
  type: SuccessType;
  onDismiss: () => void;
}): React.JSX.Element | null {
  useEffect(() => {
    if (type) {
      const timer = setTimeout(onDismiss, 2000);
      return () => clearTimeout(timer);
    }
  }, [type, onDismiss]);

  const isSent = type === 'sent';
  const circleColor = isSent ? COLORS.blue : COLORS.green;
  const mainText = isSent ? 'Order sent!' : 'Delivery confirmed!';
  const subText = isSent ? null : 'Inventory updated';

  return (
    <AnimatePresence>
      {type && (
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          transition={{ duration: 0.3 }}
          className={styles.successOverlay}
        >
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ type: 'spring', stiffness: 300, damping: 20, delay: 0.1 }}
            className={styles.successCircle}
            style={{ background: circleColor }}
          >
            {isSent ? (
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 2L11 13" />
                <path d="M22 2L15 22L11 13L2 9L22 2Z" />
              </svg>
            ) : (
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 6L9 17L4 12" />
              </svg>
            )}
          </motion.div>
          <div className={styles.successMainText}>{mainText}</div>
          {subText && (
            <div className={styles.successSubText}>{subText}</div>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
